import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BloodSampleActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-blood-sample-slot-v2',
    templateUrl: './blood-sample-slot-v2.component.html',
    styleUrl: './blood-sample-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodSampleSlotComponentV2 implements SheetSlotComponentBase {

	@Input() action!: BloodSampleActionV2;
	value = null;

	constructor() {
	}
}